<template>
  <div class="settings">
    <h1>DICOM</h1>
    <br />
    <table class="table" style="padding-left: 20px; width: 95%">
      <tbody class="tbody">
        <th
          colspan="3"
          class="th"
          style="text-align: left; vertical-align: middle; line-height: 60px"
        >
          <div style="display: flex; align-items: center">
            <span @click="changeEnableDicom">{{ `${$t(`langcfg.txtEnableDICOM`)}:` }}</span>
            <input
              type="checkbox"
              class="input-open-dicom"
              :checked="enable"
              @click="changeEnableDicom"
            />
          </div>
        </th>
        <tr class="tr">
          <td class="td-40-percent" colspan="2">
            <div class="dicom-header-item">Work List</div>
          </td>
          <td class="td-10-percent"></td>
          <td class="td-40-percent" colspan="2">
            <div class="dicom-header-item">PDF</div>
          </td>
        </tr>
        <tr class="tr" v-for="(item, key) in workListSet" :key="key">
          <td class="td-20-percent">{{ $t(`langcfg.${item.label}`) }}:</td>
          <td class="td-20-percent" style="text-align: left">
            <el-input
              autofocus
              v-model.lazy="item.value"
              @click.native.stop.prevent="handleClickWorklist(key)"
              @touchend.native.stop.prevent="handleClickWorklist(key)"
              @change="saveDicomSettings(false)"
            ></el-input>
          </td>
          <td class="td-10-percent" style="text-align: left"></td>
          <td class="td-20-percent">{{ $t(`langcfg.${pdfSet[key].label}`) }}:</td>
          <td class="td-20-percent">
            <el-input
              autofocus
              v-model.lazy="pdfSet[key].value"
              @click.native.stop.prevent="handleClickPDF(key)"
              @touchend.native.stop.prevent="handleClickPDF(key)"
              @change="saveDicomSettings(false)"
            ></el-input>
          </td>
        </tr>
        <tr class="tr">
          <td class="td-20-percent">{{ $t(`langcfg.txtCharSet`) }}:</td>
          <td class="td-20-percent" style="text-align: left">
            <select class="charset" v-model="workChartSet" @change="saveDicomSettings(false)">
              <option value="utf8" class="charset-option">UTF8</option>
              <option value="gbk" class="charset-option">GBK</option>
            </select>
          </td>
          <td class="td-10-percent"></td>
          <td class="td-20-percent">{{ $t(`langcfg.txtCharSet`) }}:</td>
          <td class="td-20-percent" style="text-align: left">
            <select class="charset" v-model="pdfChartSet" @change="saveDicomSettings(false)">
              <option value="utf8" class="charset-option">UTF8</option>
              <option value="gbk" class="charset-option">GBK</option>
            </select>
          </td>
        </tr>
        <tr class="tr">
          <td class="td-20-percent">
            {{ `${$t("langcfg.txtStartDate")}:` }}
          </td>
          <td class="td-20-percent">
            <div style="width: 100%; display: flex">
              <el-date-picker
                @change="dateTimeChanged($event, 'startDate')"
                style="width: 90%"
                format="yyyy-MM-dd"
                v-model="startDate"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button style="width: 10%"
                ><span class="el-icon-delete" @click="clearDate('startDate')"></span
              ></el-button>
            </div>
          </td>
        </tr>
        <tr class="tr">
          <td class="td-20-percent">
            {{ `${$t("langcfg.txtEndDate")}:` }}
          </td>
          <td class="td-20-percent">
            <div style="width: 100%; display: flex">
              <el-date-picker
                @change="dateTimeChanged($event, 'endDate')"
                style="width: 90%"
                format="yyyy-MM-dd"
                v-model="endDate"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button style="width: 10%"
                ><span class="el-icon-delete" @click="clearDate('endDate')"></span
              ></el-button>
            </div>
          </td>
        </tr>
        <tr class="tr">
          <td class="td-20-percent">
            {{ `${$t("langcfg.txtDICOMUpdateInterval")}(s):` }}
          </td>
          <td class="td-20-percent">
            <el-input-number
              v-model.lazy="interval"
              :min="5"
              :max="100"
              label="input"
              class="charset"
              @change="saveDicomSettings(false)"
              @focus="handleClick"
            ></el-input-number>
          </td>
          <td class="td-10-percent"></td>
          <td class="td-20-percent"></td>
          <td class="td-20-percent"></td>
        </tr>
        <tr style="height: 50px"></tr>
        <tr class="tr">
          <td class="td-20-percent" colspan="2" align="center">
            <el-button @click="testWorklist" class="btn-operator"
              ><span class="el-icon-loading waitting-icon" v-if="isWorklistTesting"></span
              >{{ btnTestWorklist }}</el-button
            >
          </td>
          <td class="td-10-percent"></td>
          <td class="td-20-percent" colspan="2" align="center">
            <el-button @click="testPDF" class="btn-operator"
              ><span class="el-icon-loading waitting-icon" v-if="isPdfTesting"></span
              >{{ btnTestPDF }}</el-button
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Dicom from "../../js/dicom/Dicom";
import { DICOMSETTINGS } from "../../../shared/consts";
import { canConvertNumber, isStringEmpty, objectCopy } from "../../../shared/utils";
import { Message } from "../../../mixins";
import EVENTS from "../../../bus";
import { saveDicomSettings } from "../../../settings";
import { mapState } from "vuex";
import home from "../../../store/modules/home";

let timeout;
let dicom = new Dicom();
export default {
  name: "Dicom",
  data() {
    return {
      workListSet: objectCopy(DICOMSETTINGS),
      pdfSet: objectCopy(DICOMSETTINGS),
      workChartSet: "utf8",
      pdfChartSet: "utf8",
      startDate: "",
      endDate: "",
      isPdfTesting: false,
      isWorklistTesting: false,
      enable: true,
      interval: 30
    };
  },
  mixins: [Message],
  created() {
    let { worklist, pdf } = window.dicomSettings;
    for (let id in DICOMSETTINGS) {
      this.workListSet[id].value = worklist[id];
      this.pdfSet[id].value = pdf[id];
    }
    this.workChartSet = worklist.worklistcharset;
    this.pdfChartSet = pdf.worklistcharset;
    this.enable = window.dicomSettings.enable;
    this.interval = window.dicomSettings.interval;
    this.startDate = window.dicomSettings.worklist.startDate;
    this.endDate = window.dicomSettings.worklist.endDate;
  },
  mounted() {
    dicom.on("dicom-test-failed", (info) => {
      this.isWorklistTesting = false;
      this.isPdfTesting = false;
      this.notify(this.$t("langcfg.txtDicomTestFailed"), "", "error", 3000);
    });
    dicom.on("dicom-test-success", (info) => {
      this.isWorklistTesting = false;
      this.isPdfTesting = false;
      this.notify(this.$t("langcfg.txtDicomTestSuccess"), "", "success", 3000);
    });
    this.$bus.$on("dicom-disabled", () => {
      this.enable = false;
      window.dicomSettings.enable = true;
    });
    this.enable = window.dicomSettings.enable;
    if (this.enable) {
      timeout = setTimeout(() => {
        dicom.downLoadPatient(() => {
          this.$bus.$emit(EVENTS.refreshPatients);
        });
      }, 1000);
    } else {
      timeout = setTimeout(() => {
        dicom.stopDownloadPatient();
      }, 1000);
    }
    // /
    this.watchSetStatus();
    let input = document.getElementsByClassName("el-input__inner");
    input[13].addEventListener("touchend", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.$bus.$emit(EVENTS.spreadKeyBoard, this.interval, (value) => {
        this.interval = value;
      });
    });
    input[13].addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.$bus.$emit(EVENTS.spreadKeyBoard, this.interval, (value) => {
        this.interval = value;
      });
    });
  },
  computed: {
    btnTestPDF() {
      return this.isPdfTesting ? this.$t("langcfg.txtTesting") : this.$t("langcfg.txtTest");
    },
    btnTestWorklist() {
      return this.isWorklistTesting ? this.$t("langcfg.txtTesting") : this.$t("langcfg.txtTest");
    },
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    })
  },
  methods: {
    clearDate(key) {
      this[key] = "";
      this.saveDicomSettings(false);
    },
    dateTimeChanged() {
      this.saveDicomSettings(false);
    },
    handleClickWorklist(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.workListSet[key].value, (value) => {
        self.workListSet[key].value = value;
      });
    },
    handleClickInterval() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.interval, (value) => {
        self.interval = value;
      });
    },
    handleClickPDF(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.pdfSet[key].value, (value) => {
        self.pdfSet[key].value = value;
      });
    },
    handleClick() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.interval.toString(), (value) => {
        if (canConvertNumber(value)) {
          self.interval = parseInt(value);
          this.saveDicomSettings(false);
        }
      });
    },
    changeEnableDicom() {
      this.saveDicomSettings(false);
      clearTimeout(timeout);
      this.enable = !this.enable;
      window.dicomSettings.enable = this.enable;

      saveDicomSettings(window.dicomSettings);
      if (this.enable) {
        timeout = setTimeout(() => {
          dicom.downLoadPatient(() => {
            this.$bus.$emit(EVENTS.refreshPatients);
          });
        }, 1000);
      } else {
        timeout = setTimeout(() => {
          dicom.stopDownloadPatient();
        }, 1000);
      }
    },
    testWorklist() {
      this.isWorklistTesting = true;
      this.saveDicomSettings(false);

      dicom.testDicom(window.dicomSettings.worklist);
    },
    testPDF() {
      this.isPdfTesting = true;
      this.saveDicomSettings(false);
      dicom.testPdf(window.dicomSettings.pdf);
    },
    setTipText(txt) {
      let timeout = setTimeout(() => {
        this.txtTip = txt;
      }, 200);
    },
    checkConfigValid() {
      let isOK = true;
      if (
        isStringEmpty(this.pdfSet.serverip.value) ||
        isStringEmpty(this.workListSet.serverip.value) ||
        isNaN(parseInt(this.workListSet.serverport.value)) ||
        isNaN(parseInt(this.pdfSet.serverport.value))
      ) {
        isOK = false;
      }
      return isOK;
    },
    saveDicomSettings(ifShow = true) {
      let isOK = this.checkConfigValid();
      if (isOK) {
        for (let id in DICOMSETTINGS) {
          window.dicomSettings.worklist[id] = this.workListSet[id].value;
          window.dicomSettings.pdf[id] = this.pdfSet[id].value;
        }
        window.dicomSettings.worklist.worklistcharset = this.workChartSet;
        window.dicomSettings.pdf.worklistcharset = this.pdfChartSet;
        window.dicomSettings.interval = this.interval;
        window.dicomSettings.enable = this.enable;
        window.dicomSettings.worklist.startDate = this.startDate;
        window.dicomSettings.worklist.endDate = this.endDate;
        saveDicomSettings(window.dicomSettings);
      }
      if (ifShow) {
        let message = isOK
          ? this.$t(`langcfg.txtSaveSuccess`)
          : this.$t(`langcfg.txtIPOrPortError`);
        let type = isOK ? "success" : "error";
        this.notify(message, "", type, 3000);
      }
    },
    toPdf() {
      for (let id in this.workListSet) {
        this.pdfSet[id].value = this.workListSet[id].value;
      }
      this.pdfChartSet = this.workChartSet;
    },
    toWorkList() {
      for (let id in this.pdfSet) {
        this.workListSet[id].value = this.pdfSet[id].value;
      }
      this.workChartSet = this.pdfChartSet;
    },
    // /
    watchSetStatus() {
      let _this = this;
      this.$bus.$on(EVENTS.setDicom, function (msg) {
        _this.isWorklistTesting = msg.isWorklistTesting;
        _this.isPdfTesting = msg.isPdfTesting;
        // _this.saveDicomSettings(msg.ifShow)
        dicom.testDicom(msg.dicomSettings.worklist);
        if (msg.isOK) {
          for (let id in DICOMSETTINGS) {
            window.dicomSettings.worklist[id] = msg.dicomSettings.worklist[id];
            window.dicomSettings.pdf[id] = msg.dicomSettings.pdf[id];
          }
          window.dicomSettings.worklist.worklistcharset =
            msg.dicomSettings.worklist.worklistcharset;
          window.dicomSettings.pdf.worklistcharset = msg.dicomSettings.pdf.worklistcharset;
          window.dicomSettings.interval = msg.dicomSettings.interval;
          window.dicomSettings.enable = msg.dicomSettings.enable;
          saveDicomSettings(window.dicomSettings);
        }
        if (msg.ifShow) {
          let message = msg.isOK
            ? this.$t(`langcfg.txtSaveSuccess`)
            : this.$t(`langcfg.txtIPOrPortError`);
          let type = msg.isOK ? "success" : "error";
          _this.notify(message, "", type, 3000);
        }
        for (let id in _this.workListSet) {
          _this.workListSet[id].value = msg.dicomSettings.worklist[id];
        }
        for (let id in _this.pdfSet) {
          _this.pdfSet[id].value = msg.dicomSettings.pdf[id];
        }
        //
        _this.workChartSet = msg.dicomSettings.worklist.worklistcharset;
        _this.pdfChartSet = msg.dicomSettings.pdf.worklistcharset;
        _this.enable = msg.dicomSettings.enable;
        _this.interval = msg.dicomSettings.interval;
      });
    }
  },
  watch: {
    enable(val) {
      window.dicomSettings.enable = val;
      this.saveDicomSettings(false);
      this.$bus.$emit(EVENTS.dicomStart, val);
    }
  },
  beforeDestroy() {
    this.$bus.$off("dicom-disabled");
    this.$bus.$off(EVENTS.setDicom);
  }
};
</script>
<style lang="less" scoped>
.settings {
  width: 100%;
  margin-top: 60px;
  margin-left: 15px;
  font-size: 23px;
  color: white;
  display: flex;
  align-items: left;
  flex-direction: column;
}
.el-button {
  font-size: 40px;
}
.el-form-item {
  line-height: 30px;
}
.dicom {
  width: 90%;

  margin-left: 20px;
}

.el-form /deep/ .el-form-item__label {
  font-size: 28px;
  padding: 0px;
  line-height: 40px;
}
.el-form /deep/ .el-form-item {
  margin-top: 20px;
}
.el-input-number /deep/ .el-input__inner {
  text-align: left;
  // padding-left: 15px;
}
.dicom-header {
  display: flex;
  height: 50px;
  margin-top: 20px;
  cursor: pointer;
  color: white;
}
.dicom-header-item {
  width: 50%;
  color: white;
  text-align: left;
  padding-left: 200px;
}
.worklist {
  border-right: 1px solid gray;
}
.dicom-content {
  display: flex;
}
.dicom-content-item {
  width: 40%;
}
.charset {
  width: 100%;
  border: #dcdfe6;
  border-radius: 4px;
  border-right: none;
  font-size: 30px;
  background: white;
  outline: none;
  height: 45px;
  color: #606266;
}
.dicom-start {
  display: flex;
}
.input-open-dicom {
  padding: 0px;
  border: none;
  width: 35px;
  height: 35px;
  margin-left: 30px;
}

.td-40-percent {
  width: 40%;
}
.td-20-percent {
  width: 20%;
}
.td-10-percent {
  width: 10%;
}
.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}

.btn-operator {
  border: 1px gray solid;
  height: @header-fs+50px;
  width: 250px;
}
// .charset /deep/ .el-input-number__increase,
// .charset /deep/ .el-input-number__decrease {
//   display: none;
// }
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Dicom.vue